import { useEffect } from "react"
import { useRecoilState } from "recoil"
import { getShopAgents } from "../repositories/agentRepo"
import agentListState from "../state/agentListState"


export const useShopAgents = (shopId) => {
  const [agents, setAgents] = useRecoilState(agentListState)

  useEffect(() => {
    if (!shopId) return;
    getShopAgents(shopId).then((agents) => {
      setAgents(agents)
    });
  }, [shopId])
  return [agents, setAgents]
}
